export default __webpack_public_path__ + "static/media/vrbo_new.79766573.PNG";